import { NewInspectionInDto, NewInspectionOutDto } from '../../../types/inspection.dto'

export const NEW_INSPECTION = 'NEW_INSPECTION'
export const NEW_INSPECTION_SUCCESS = 'NEW_INSPECTION_SUCCESS'
export const NEW_INSPECTION_ERROR = 'NEW_INSPECTION_ERROR'
export const RESET_NEW_INSPECTION = 'RESET_NEW_INSPECTION'

export interface NewInspection {
  type: typeof NEW_INSPECTION
  payload: NewInspectionOutDto
}

export interface NewInspectionSuccess {
  type: typeof NEW_INSPECTION_SUCCESS
  payload: NewInspectionInDto
}

export interface NewInspectionError {
  type: typeof NEW_INSPECTION_ERROR
  payload: string | boolean
}

export interface ResetNewInspection {
  type: typeof RESET_NEW_INSPECTION
  payload: null
}

export interface State {
  data: NewInspectionInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewInspection | NewInspectionSuccess | NewInspectionError | ResetNewInspection
